import { useMemo } from "react";
import {
  DAYJS_FORMAT_STRING,
  DATE_PICKER_FORMAT_STRING,
  DateFormatType,
  TIME_PICKER_FORMAT_STRING,
  TimeFormatType,
  DAYJS_TIME_FORMAT_STRING,
} from "interfaces/models/inspectionItemResult";
import { PickerMode, PICKER_MODE } from "../constants";

/**
 * Hook to manage format strings based on picker mode
 */
export const usePickerFormats = (mode: PickerMode, formatType: DateFormatType | TimeFormatType) => {
  return useMemo(() => {
    const pickerFormat =
      mode === PICKER_MODE.DATE
        ? DATE_PICKER_FORMAT_STRING[formatType as DateFormatType]
        : TIME_PICKER_FORMAT_STRING[formatType as TimeFormatType];

    const dayJsFormat =
      mode === PICKER_MODE.DATE
        ? DAYJS_FORMAT_STRING[formatType as DateFormatType]
        : DAYJS_TIME_FORMAT_STRING[formatType as TimeFormatType];

    const validationMessage = mode === PICKER_MODE.DATE ? "日付形式が無効です" : "時間形式が無効です";

    return { pickerFormat, dayJsFormat, validationMessage };
  }, [mode, formatType]);
};
